import { lessonActionTypes } from './Constants';
import { change } from 'redux-form';

export function getLessonDetailsRequest(userId, lessonId) {
	return {
		type: lessonActionTypes.GET_LESSON_DETAILS_REQUEST,
		payload: {
			userId,
			lessonId,
		},
	};
}

export function getLessonDetailsSuccess(data) {
	return {
		type: lessonActionTypes.GET_LESSON_DETAILS_SUCCESS,
		payload: {
			data,
		},
	};
}

export function getLessonDetailsError(error) {
	return {
		type: lessonActionTypes.GET_LESSON_DETAILS_ERROR,
		payload: {
			error,
		},
	};
}

export function sendFeedbackRequest(data, callback) {
	return {
		type: lessonActionTypes.SEND_FEEDBACK_REQUEST,
		payload: {
			data,
			callback,
		},
	};
}

export function sendFeedbackSuccess(data) {
	return {
		type: lessonActionTypes.SEND_FEEDBACK_SUCCESS,
		payload: {
			data,
		},
	};
}

export function sendFeedbackError(error) {
	return {
		type: lessonActionTypes.SEND_FEEDBACK_ERROR,
		payload: {
			error,
		},
	};
}

export function changeFormField(formName, fieldName, value) {
	return change(formName, fieldName, value);
}

export function setShowSuccessFeedback(show) {
	return {
		type: lessonActionTypes.SHOW_SUCCESS_FEEDBACK,
		payload: {
			show,
		},
	};
}

export function getScheduledLessonStudents(data) {
	return {
		type: lessonActionTypes.GET_SCHEDULED_LESSON_STUDENTS_REQUEST,
		payload: {
			data,
		},
	};
}

export function getScheduledLessonStudentsSuccess(data) {
	return {
		type: lessonActionTypes.GET_SCHEDULED_LESSON_STUDENTS_SUCCESS,
		payload: {
			data,
		},
	};
}

export function getScheduledLessonStudentsError(error) {
	return {
		type: lessonActionTypes.GET_SCHEDULED_LESSON_STUDENTS_ERROR,
		payload: {
			error,
		},
	};
}

export function manageStudentStatus(data, status) {
	return {
		type: lessonActionTypes.MANAGE_STUDENT_STATUS_REQUEST,
		payload: {
			data,
			status,
		},
	};
}

export function manageStudentStatusSuccess(data) {
	return {
		type: lessonActionTypes.MANAGE_STUDENT_STATUS_SUCCESS,
		payload: {
			data,
		},
	};
}

export function manageStudentStatusError(error) {
	return {
		type: lessonActionTypes.MANAGE_STUDENT_STATUS_ERROR,
		payload: {
			error,
		},
	};
}
